module.exports = __webpack_public_path__ + "assets/img/logo.7a9bdbf7.png";